import { createContext, useEffect, useState } from 'react';
import { useOktaAuth } from '@okta/okta-react';

export const WorkforceContext = createContext({});

export const WorkforceContextProvider = ({ children, impersonatedId }) => {
    const {
        authState: {
            accessToken: { accessToken, claims },
            idToken,
        },
    } = useOktaAuth();
    const [biddingGroup, setBiddingGroup] = useState();
    const [triggerRefresh, setTriggerRefresh] = useState(false);
    const [activeJobBids, setActiveJobBids] = useState();
    const [error, setError] = useState();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let ignore = false;
        setLoading(true);
        const fetchData = async () => {
            if (!ignore) {
                const bidGroupRequest = fetch(
                    `${process.env.REACT_APP_API_ENDPOINT}/settings/bid-group`,
                    {
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                            actingAs: impersonatedId,
                        },
                    }
                );
                const jobBidsRequest = fetch(
                    `${process.env.REACT_APP_API_ENDPOINT}/bids/my-active-job-bids`,
                    {
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                            actingAs: impersonatedId,
                        },
                    }
                );

                const [biddingGroupResponse, jobBidsResponse] =
                    await Promise.all([bidGroupRequest, jobBidsRequest]);
                if (!biddingGroupResponse.ok || !jobBidsResponse.ok) {
                    setError(true);
                } else {
                    const bidGroup = await biddingGroupResponse.json();
                    setBiddingGroup(bidGroup);

                    const jobBids = await jobBidsResponse.json();
                    setActiveJobBids(jobBids);
                    setError(false);
                }
            }
            setLoading(false);
        };

        fetchData();
        return () => {
            ignore = true;
        };
    }, [accessToken, impersonatedId, triggerRefresh]);

    const workforceContextValue = {
        loading,
        error,
        biddingGroup,
        activeJobBids,
        racfId: claims.userID,
        title: idToken.claims.title,
        setTriggerRefresh,
        setActiveJobBids,
    };

    return (
        <WorkforceContext.Provider value={workforceContextValue}>
            {children}
        </WorkforceContext.Provider>
    );
};
